import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { MIN_PROPERTY_WIDTH, MIN_PROPERTY_HEIGHT } from "@utils/constant";
import NumberInput from "./shared/NumberInput";

function getScaledWidth(selectedObject: fabric.Object | null) {
  return Math.round(
    (selectedObject?.width || MIN_PROPERTY_WIDTH) *
      (selectedObject?.scaleX || 1)
  );
}

function Width() {
  const {
    canvas,
    selectedObject,
    coreHandler,
    isWidthHeightProportionalScaled,
  } = useContext(AppContext);
  const [width, setWidth] = useState(getScaledWidth(selectedObject));

  // triggered by clicking layers
  useEffect(() => {
    setWidth(getScaledWidth(selectedObject));
  }, [selectedObject]);

  // triggered by fabric controls
  useEffect(() => {
    function onModified(event: any) {
      const newWidth = getScaledWidth(selectedObject);
      setWidth(newWidth);
    }

    coreHandler?.eventHandler.on("object:modified", onModified);
    return () => {
      coreHandler?.eventHandler.off("object:modified", onModified);
    };
  }, [coreHandler, selectedObject]);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newWidth = Math.max(
      MIN_PROPERTY_WIDTH,
      parseInt(event.target.value, 10)
    );

    if (!selectedObject) return;

    const newScaleX = newWidth / (selectedObject.width || MIN_PROPERTY_WIDTH);

    if (isWidthHeightProportionalScaled) {
      // Calculate proportional height to maintain aspect ratio
      const currentAspectRatio =
        (selectedObject.width || MIN_PROPERTY_WIDTH) /
        (selectedObject.height || MIN_PROPERTY_HEIGHT);
      const newHeight = newWidth / currentAspectRatio;
      const newScaleY =
        newHeight / (selectedObject.height || MIN_PROPERTY_HEIGHT);

      // Ensure minimum height constraint
      const constrainedScaleY = Math.max(
        MIN_PROPERTY_HEIGHT / (selectedObject.height || MIN_PROPERTY_HEIGHT),
        newScaleY
      );

      selectedObject.set({
        scaleX: newScaleX,
        scaleY: constrainedScaleY,
      });
    } else {
      selectedObject.set("scaleX", newScaleX);
    }

    setWidth(newWidth);
    // @ts-ignore - TODO - fix this later
    coreHandler?.eventHandler.modified({ target: selectedObject });
    canvas?.renderAll();
  }

  return (
    <NumberInput onChange={onChange} value={width} min={MIN_PROPERTY_WIDTH} />
  );
}

export default Width;
